import { Link } from "react-router-dom";
import { FB, IG, LinkedIn, X } from "./constants";

const Footer = () => {
  return (
    <footer className="bg-[#084DC5] text-white py-12">
      <div className="container  px-3 ">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[2.2fr_1fr_1fr_1fr] gap-10">
          <div>
            <Link to="/">
              <img
                src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1755225926/powerdbyai/logo-white_hg9wzw.svg"
                alt="Logo"
                className="mb-[24px]"
              />
            </Link>
            <p className="text-[#FAFAFA]">
              Empowering Africa's vision through cutting-edge computer vision
              solutions. From data annotation to model deployment, we're
              building the future of AI in Africa.
            </p>
          </div>

          <div>
            <h4 className="text-lg md:text-[24px] font-bold mb-4 md:!mb-[32px]">
              Company
            </h4>
            <ul className="space-y-3 lg:space-y-[24px]">
              <li>
                <Link
                  to="/"
                  className="text-[#FAFAFA] hover:text-white transition-colors text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/data-annotation"
                  className="text-[#FAFAFA] hover:text-white transition-colors text-sm"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/small-language-models"
                  className="text-[#FAFAFA] hover:text-white transition-colors text-sm"
                >
                  Models
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-[#FAFAFA] hover:text-white transition-colors text-sm"
                >
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="text-lg md:text-[24px] font-bold mb-4 md:!mb-[32px]">
              Resources
            </h4>
            <ul className="space-y-3 lg:space-y-[24px]">
              <li>
                <a
                  href="/#faq"
                  className="text-[#FAFAFA] hover:text-white transition-colors text-sm"
                >
                  FAQ
                </a>
              </li>
              <li>
                <Link
                  to="/support"
                  className="text-[#FAFAFA] hover:text-white transition-colors text-sm"
                >
                  Support Center
                </Link>
              </li>
              <li>
                <Link
                  to="/case-studies"
                  className="text-[#FAFAFA] hover:text-white transition-colors text-sm"
                >
                  Case Studies
                </Link>
              </li>
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="text-lg md:text-[24px] font-bold mb-4 md:!mb-[32px]">
              Support
            </h4>
            <ul className="space-y-3 lg:space-y-[24px]">
              <li>
                <Link
                  to="/privacy"
                  className="text-[#FAFAFA] hover:text-white transition-colors text-sm"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-[#FAFAFA] hover:text-white transition-colors text-sm"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 md:mt-[60px] flex flex-col md:flex-row justify-between items-center">
          <p className="text-[#FAFAFA] text-sm lg:text-base mb-[24px] md:mb-0">
            © {new Date().getFullYear()} Powered by AI. Proudly built in Africa
            for Africa and the world.
          </p>

          <div className="flex space-x-5 z-[100000]">
            <Link
              to="https://www.linkedin.com/company/2699628"
              target="_blank"
              className="text-[#FAFAFA] hover:text-white transition-colors"
            >
              <LinkedIn />
            </Link>
            <Link
              to="https://www.instagram.com/analyticsintelligence/"
              target="_blank"
              className="text-[#FAFAFA] hover:text-white transition-colors"
            >
              <IG />
            </Link>
            <Link
              to="https://twitter.com/_AnalyticsIntel"
              target="_blank"
              className="text-[#FAFAFA] hover:text-white transition-colors"
            >
              <X />
            </Link>
            <Link
              to="https://www.facebook.com/Analyticsintel/"
              target="_blanks"
              className="text-[#FAFAFA] hover:text-white transition-colors"
            >
              <FB />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
